export default function AuthorSection() {
  return (
    <section id="author" className="py-16 bg-gradient-to-br from-amber-50 via-rose-50 to-purple-50">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-rose-500 to-amber-500 text-white px-4 py-2 rounded-full mb-4 shadow-lg text-sm">
              <i className="ri-user-heart-line text-base"></i>
              <span className="font-semibold whitespace-nowrap">Meet the Author</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-3 bg-gradient-to-r from-rose-600 to-amber-600 bg-clip-text text-transparent">
              About L.J. Boydston ✨
            </h2>
          </div>

          {/* Author Bio */}
          <div className="bg-white rounded-3xl shadow-xl p-6 mb-10 transform hover:scale-[1.02] transition-all duration-300">
            <div className="grid md:grid-cols-3 gap-6 items-center">
              {/* Author Image */}
              <div className="flex justify-center">
                <div className="relative group">
                  <div className="absolute -inset-2 bg-gradient-to-r from-rose-400 to-amber-400 rounded-full blur opacity-30 group-hover:opacity-50 transition duration-300"></div>
                  <img
                    src="https://public.readdy.ai/ai/img_res/398b6710b1ec8b2d5df4be5022187a29.jpg"
                    alt="L.J. Boydston - Author"
                    className="relative w-48 h-48 object-cover rounded-full shadow-2xl border-4 border-white"
                  />
                </div>
              </div>

              {/* Bio Text */}
              <div className="md:col-span-2">
                <h3 className="text-xl md:text-2xl font-bold mb-3 text-gray-800">
                  Creating Magic Through Stories 📖
                </h3>
                <p className="text-sm text-gray-600 mb-3 leading-relaxed">
                  L.J. Boydston is a passionate children's book author dedicated to creating stories that inspire 
                  young minds and spark imagination. With a love for nature and education, she crafts tales that 
                  teach valuable life lessons while entertaining young readers.
                </p>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Through her beloved Garden Patch Kids series, L.J. brings the wonders of the natural world to 
                  life, encouraging children to explore, question, and discover the magic all around them. Each 
                  book is carefully written to engage young readers while fostering a love for learning and nature.
                </p>
              </div>
            </div>
          </div>

          {/* Quote Section */}
          <div className="bg-gradient-to-r from-teal-500 to-purple-500 rounded-3xl shadow-xl p-6 mb-10 text-white text-center transform hover:scale-[1.02] transition-all duration-300">
            <i className="ri-double-quotes-l text-3xl mb-3 opacity-50"></i>
            <blockquote className="text-lg md:text-xl font-medium mb-3 italic">
              "Every child deserves stories that make them wonder, learn, and dream. 
              Through my books, I hope to plant seeds of curiosity that will grow into 
              a lifelong love of reading and nature."
            </blockquote>
            <p className="text-sm font-semibold">— L.J. Boydston</p>
          </div>

          {/* Stats/Achievements */}
          <div className="grid md:grid-cols-3 gap-4">
            <div className="bg-white rounded-2xl p-5 shadow-lg text-center transform hover:scale-105 transition-all duration-300">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-book-line text-xl text-white"></i>
              </div>
              <h4 className="text-2xl font-bold text-teal-600 mb-1">4+</h4>
              <p className="text-sm text-gray-600">Books Published</p>
            </div>

            <div className="bg-white rounded-2xl p-5 shadow-lg text-center transform hover:scale-105 transition-all duration-300">
              <div className="w-12 h-12 bg-gradient-to-br from-purple-400 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-quill-pen-line text-xl text-white"></i>
              </div>
              <h4 className="text-2xl font-bold text-purple-600 mb-1">20+</h4>
              <p className="text-sm text-gray-600">Years of Writing</p>
            </div>

            <div className="bg-white rounded-2xl p-5 shadow-lg text-center transform hover:scale-105 transition-all duration-300">
              <div className="w-12 h-12 bg-gradient-to-br from-rose-400 to-rose-600 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-heart-line text-xl text-white"></i>
              </div>
              <h4 className="text-2xl font-bold text-rose-600 mb-1">∞</h4>
              <p className="text-sm text-gray-600">Happy Young Readers</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
